import styled, { css } from 'styled-components/macro';

import { InputCaption } from 'components/Text';
import { defaultFocusStyles } from 'theme/themeConstants';

export const StyledLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

export const StyledLabelAndFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ horizontalLayout, tooltip, isCheckBox }) => {
    const style = `${InputCaption} {
      margin-right: 1rem;
      margin-bottom: 0;
    }`;

    const checkBoxStyle = css`
      & input:focus-visible {
        & + .chakra-checkbox__control {
          ${defaultFocusStyles}
        }
      }
      & .chakra-checkbox__label a:focus-visible {
        ${defaultFocusStyles}
      }
    `;

    if (horizontalLayout) {
      return css`
        flex-direction: row;
        ${style}
      `;
    } else if (tooltip && isCheckBox) {
      return css`
        flex-direction: row-reverse;
        justify-content: start;
        ${checkBoxStyle}
        ${style}
      `;
    } else if (isCheckBox) {
      return css`
        ${checkBoxStyle}
      `;
    }
  }}
`;

export const StyledErrorWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.3rem;
`;

/**
 * Footer row below a field, holding the error message on the left and an optional trailing
 * element (e.g. a character counter) on the right. Only rendered when a field passes
 * `footerRight`, so fields without one keep their original markup.
 */
export const StyledFieldFooter = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
`;

export const StyledFieldFooterMessage = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const StyledCaptionWrapper = styled.div`
  display: flex;
  align-items: center;
`;
